// extracted by mini-css-extract-plugin
export default {"container":"DriverCollections_container__w88-3"};